import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Tooltip,
  styled,
} from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import BreadcrumbsManager from './BreadcrumbsManager';
import PinguChatLauncher from './PinguChatLauncher';

// import NavbarNotificationsDropdown from './NavbarNotificationsDropdown';
// import NavbarLanguagesDropdown from './NavbarLanguagesDropdown';
import NavbarUserDropdown from './NavbarUserDropdown';

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  background: theme.header.background,
  color: theme.header.color,
}));

const IconButton = styled(MuiIconButton)({
  '& svg': {
    width: 22,
    height: 22,
  },
});

const getToggle = (collapsible: boolean, collapsed: boolean): {
  label: string;
  icon: React.ReactNode;
} => {
  if (!collapsible) {
    return { label: 'Open drawer', icon: <MenuOpenIcon /> };
  }
  // The same icon as the overlay toggle, mirrored so its arrow points the way the menu will go
  if (collapsed) {
    return { label: 'Expand menu', icon: <MenuOpenIcon sx={{ transform: 'scaleX(-1)' }} /> };
  }
  return { label: 'Collapse menu', icon: <MenuOpenIcon /> };
};

const Navbar = ({
  onDrawerToggle,
  collapsible = false,
  collapsed = false,
}: {
  onDrawerToggle?: () => void;
  collapsible?: boolean;
  collapsed?: boolean;
}) => {
  const toggle = getToggle(collapsible, collapsed);
  const toggleButton = onDrawerToggle && (
    <IconButton
      color="inherit"
      aria-label={toggle.label}
      onClick={onDrawerToggle}
      size="medium"
    >
      {toggle.icon}
    </IconButton>
  );

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center" spacing={5}>
          <Grid>
            {toggleButton && collapsible
              ? <Tooltip title={toggle.label}>{toggleButton}</Tooltip>
              : toggleButton}
          </Grid>
          <Grid size="grow">
            <BreadcrumbsManager />
          </Grid>
          <Grid>
            {/* <NavbarNotificationsDropdown />
              <NavbarLanguagesDropdown /> */}
            <PinguChatLauncher />
            <NavbarUserDropdown />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

Navbar.propTypes = {
  onDrawerToggle: PropTypes.func,
  collapsible: PropTypes.bool,
  collapsed: PropTypes.bool,
};

export default Navbar;
